export default {
  API: "api",
  SFTP: "sftp",
};
